<div class="payments-container line" *ngIf="payments">
  <div class="payments-container-label">
    <span>{{ "webPos.ListOfPayments" | translate }} </span>
  </div>

  <div class="payments-info" *ngFor="let payment of (payments | orderBy: 'PaidDate':'desc')">
    <div class="payments-info-block date">
      <span class="date" [title]="getPaymentDateTime(payment) | localizedDateTime">{{ payment.PaidDate | localizedDate }}</span>
    </div>
    <div class="payments-info-block">
      @if (payment.PaymentDescription && payment.PaymentDescription.trim().length > 0) {
        <span class="payment-name" [title]="payment.PaymentDescription"> {{ payment.PaymentDescription }} </span>
      }
      @else if (payment.PaymentName) {
        <span class="payment-name" [title]="getPaymentDescription(payment.PaymentName) | async"> {{ getPaymentDescription(payment.PaymentName) | async }} </span>
      }
      @else if (payment.PaymentType || payment.paymentType === 0) {

        <span class="payment-name" [title]="payment.PaymentType | paymentType"> {{ payment.PaymentType | paymentType }} </span>
      }
      @else if (payment.DataBlob && payment.DataBlob.PaymentName) {
        <span class="payment-name" [title]="getPaymentDescription(payment.DataBlob.PaymentName) | async"> {{ getPaymentDescription(payment.DataBlob.PaymentName) | async }}</span>
      } 

      @if (payment.PaymentType === TenderType.Voucher) {
        <span class="voucher-code"> ({{ getVoucherCode(payment) }}) </span>
      }

      @if (payment.DataSource === 'both') {
        🔄️
      }
      @else if (payment.DataSource === 'tiger') {
        🐅
      }
      @else if (payment.DataSource === 'pos') {
        💲
      }
      
    </div>
    <div class="payments-info-block payments-info-block--amount">
      <span class="payments-info--bold" [ngClass]="getStatusClass(payment.Status, payment.Amount)" [title]="getStatusClass(payment.Status, payment.Amount)">
        {{ payment.Amount | hcurrency : payment.Currency }}
      </span>

      <button
        type="button"
        class="payments-print"
        [class.payments-print--active]="canPrintPayment(payment)"
        [title]="payment.BusinessUnitInternalNumber || 'no-business-unit'"
        [disabled]="isPrintingReceipt || !canPrintPayment(payment)"
        (click)="onPrintReceipt(payment, $event)"
        [attr.aria-label]="'webPos.PrintReceipt' | translate">
        <fa-icon [icon]="['fas', 'print']"></fa-icon>
      </button>

      <button
        *hasRole="managerRoles"
        type="button"
        class="payments-return"
        [class.payments-return--active]="canReturnPayment(payment)"
        [disabled]="isReturningPayment || !canReturnPayment(payment)"
        [title]="getReturnInfo(payment)"
        (click)="onReturnPayment(payment, $event)"
        [attr.aria-label]="'webPos.ToReturn' | translate">
        <fa-icon [icon]="['fas', 'circle-xmark']"></fa-icon>
      </button>
    </div>
  </div>
</div>
